import { BackTop, Col, Popover, Row } from 'antd'
import moment from 'moment'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import ContactFormModify from 'src/components/ContactFormModify'
import DetailNewsLayout from 'src/components/Layout/DetailNewsLayout'
import Loading from 'src/components/Loading'
import RelavantNews from 'src/components/RelavantNews'
import { SEO } from 'src/components/SEO'
import BASE_CONFIG from 'src/configs/base'
import newsService from 'src/services/news.service'
import { genImageUrl } from 'src/utils/common'
import { CloseOutlined } from '@ant-design/icons'

const DetailArticle = ({ data, seo, id }) => {
	const [topNews, setTopNews] = useState([])
	const [isHide, setIsHide] = useState(false)
	const [isFocusForm, setIsFocusForm] = useState(false)
	const router = useRouter()

	useEffect(() => {
		newsService
			.getTopNews()
			.then((resp) => {
				if (!resp.IsError) setTopNews(resp.Data)
			})
			.catch(console.log)
	}, [])

	useEffect(() => {
		newsService.getNewById(id, seo.Slug, window.location.pathname.split('/')[2]).catch(console.log)
	}, [id])

	return (
		<div className="detail__article__page">
			<div className="container">
				{!data ? (
					<Loading />
				) : (
					<div className="detail__article__page-container">
						<SEO
							data={{
								title: seo.Title,
								description: seo.Description,
								keywords: seo.Keyword,
								newsKeywords: seo.Keyword,
								thumbnailUrl: genImageUrl(data.Thumb),
								url: seo.Canonical ? seo.Canonical : BASE_CONFIG.PAGE_URL + router.asPath,
								redirect: seo.Redirect ? seo.Redirect : BASE_CONFIG.PAGE_URL + router.asPath,
								publishDate: seo.ScheduleDate
									? seo.ScheduleDate
									: moment().format('YYYY-MM-DD[T]HH:mm:ss'),
							}}
						/>
						<Row gutter={[32, 16]}>
							<Col xl={16} lg={16} md={24} sm={24} xs={24}>
								<div className="detail__article__page-detail">
									<h1 className="detail-title">{data.Name}</h1>
									<div
										className="detail-content"
										dangerouslySetInnerHTML={{ __html: data.Content }}
									/>
								</div>
							</Col>
							<Col xl={8} lg={8} md={24} sm={24} xs={24}>
								<div className="detail__article__page-relavant">
									<h3>Tin tức xem nhiều</h3>
									<ul className="relavant-list">
										{topNews?.map((e) => (
											<li key={e._id} className="list-item">
												<RelavantNews data={e} />
											</li>
										))}
									</ul>
								</div>
								<div className="detail__article__page-relavant">
									<div className="form__container" id="form-contact-crm">
										<ContactFormModify isFocusForm={isFocusForm} />
									</div>
								</div>
								{/* <div className="contact-button"></div> */}
								<BackTop style={{ bottom: 250, right: 10, display: isHide ? 'none' : '' }}>
									<div
										onClick={(e) => {
											e.stopPropagation()
											setIsHide(true)
										}}
										style={{
											height: 25,
											width: 25,
											lineHeight: '40px',
											borderRadius: '50%',
											backgroundColor: '#CC0000',
											color: '#fff',
											textAlign: 'center',
											fontSize: 14,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<CloseOutlined style={{ fontSize: 18 }} />
									</div>
								</BackTop>
								<BackTop style={{ bottom: 225, right: 210, display: isHide ? 'none' : '' }}>
									<div
										className="back-top-text"
										style={{
											height: 50,
											width: 200,
											backgroundColor: '#fff',
											color: '#000',
											textAlign: 'center',
											fontSize: 14,
											borderRadius: 10,
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											boxShadow: '0px 4px 30px 0px rgba(0, 0, 0, 0.1)',
										}}
										onClick={(e) => {
											e.stopPropagation()
											const element = document.getElementById('form-contact-crm')
											if (element) {
												element.scrollIntoView({
													behavior: 'smooth', // Optional: Use smooth scrolling
													block: 'start', // Optional: Align the top of the element with the top of the viewport
												})
											}
										}}
									>
										Điền thông tin để chúng <br /> tôi tư vấn cho bạn rõ hơn
									</div>
								</BackTop>
							</Col>
						</Row>
					</div>
				)}
			</div>
		</div>
	)
}

export const getServerSideProps = async ({ params }) => {
	const { slug, seoSlug, categorySlug } = params
	const data = await newsService.getNewById(slug, seoSlug, categorySlug)
	const notFound = !data.Data

	return {
		props: {
			data: data.Data,
			seo: data.DataSEO,
			id: slug,
			revalidate: true,
		},
		notFound,
	}
}

// export const getStaticPaths = async () => {
// 	const response = await newsService.getAllNews();
// 	const isDev = process.env.NODE_ENV === 'development'
// 	return {
// 		paths: isDev
// 			? []
// 			: response.Data.map((e) => ({
// 					params: {
// 						categorySlug: e.CategorySlug.toString(),
// 						seoSlug: e.SEO?.Slug.toString() || BASE_CONFIG.DEFAULT_SEO_SLUG,
// 						slug: e.Id.toString(),
// 					},
// 			  })),
// 		fallback: isDev || 'blocking',
// 	}
// }

DetailArticle.Layout = DetailNewsLayout
export default DetailArticle
